export interface KolFiltersState {
  social_platform_code: string[]
  categories_code: string[]
  age_groups: string[]
  gender_codes: string[]
  talent_manager_ids: string[]
  tiers: string[]
  payment_status: string[]
  profile_status: string[]
}

export const SET_KOL_FILTERS = "SET_KOL_FILTERS"
export const RESET_KOL_FILTERS = "RESET_KOL_FILTERS"

export const setKolFilters = (filters: Partial<KolFiltersState>) => ({
  type: SET_KOL_FILTERS,
  payload: filters,
})

export const resetKolFilters = () => ({
  type: RESET_KOL_FILTERS,
})
